module.exports = __webpack_public_path__ + "static/img/图层3@3x.0cb9da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/底部/图层3@3x.png
// module id = sBWE
// module chunks = 192